class Wishlist {
  constructor() {
    this.wishlist = JSON.parse(localStorage.getItem('user_wishlist')) || [];
    this.wishlistButton = document.querySelectorAll('.wishlist-btn-js');
    this.wishlistTile = document.querySelectorAll('.wishlist-grid');
    this.wishlistCount = document.querySelector('.wishlist_count');
    this.wishlist_count_mobile = document.querySelector('.wishlist_count_mobile');
    this.wishlistContainer = document.querySelector('.wishlist_container');
    this.wishlistLoader = document.querySelector('.wishlist-loader');

    this.initialize();
  }

  initialize() {
    this.updateWishlistCount();
    this.activateItemsInWishlist();
    this.loadWishlist();
    this.bindUIActions();
  }

  updateWishlistCount() {
    const wishlistCounts = document.querySelectorAll('.wishlist_count, .wishlist_count_mobile');
    wishlistCounts.forEach(el => {
      el.textContent = this.wishlist.length;
    });
  }

  toggleButtonState(button) {
    button.classList.toggle('is-active');
  }

  updateWishlist(button) { 
    const productHandle = button.getAttribute('data-product-handle');
    const isRemove = button.classList.contains('is-active');

    if (isRemove) {
      const index = this.wishlist.indexOf(productHandle);
      if (index > -1) this.wishlist.splice(index, 1);

      const tile = button.closest('.wishlist-grid');
      if (tile) tile.remove(); 
      if(this.wishlist.length == 0) {
        if( document.querySelector('.wishlist_empty_area') ) document.querySelector('.wishlist_empty_area').style.display='block';
      }
      console.log('wishlistItems ',this.wishlist.length);
    } else {
      this.wishlist.push(productHandle);
    }

    localStorage.setItem('user_wishlist', JSON.stringify(this.wishlist));

    // ─── Klaviyo: track add/remove from wishlist ──────────────────────────
 if (window._learnq) {
   const eventName = isRemove
     ? 'Removed From Wishlist'
     : 'Added To Wishlist';
   window._learnq.push(['track', eventName, {
     'Product Handle': productHandle
   }]);
 }
 // ───────────────────────────────────────────────────────────────────────


  }

  activateItemsInWishlist() {
    this.wishlistButton.forEach((button) => {
      const productHandle = button.getAttribute('data-product-handle');
      if (this.wishlist.includes(productHandle)) {
        button.classList.add('is-active');
      }
    });
  }

  displayOnlyWishlistItems() {
    if(this.wishlist.length > 0){
      this.loadWishlistItems(); // Updated function    
      // this.wishlistTile.forEach((tile) => {
      //   const productHandle = tile.getAttribute('data-product-handle');
      //   if (!this.wishlist.includes(productHandle)) {  
      //     tile.remove();
      //   }
      // });
    }else{
      document.querySelector('.wishlist_empty_area').style.display='block';
      this.wishlistLoader.style.display = 'none';
    }
  }

  loadWishlist() {
    if (window.location.href.includes('/pages/wishlist')) {
      if (this.wishlistLoader) this.wishlistLoader.style.display = 'block';
      if (this.wishlistContainer) {
        this.wishlistContainer.innerHTML = ''; // Clear previous content
        this.wishlistContainer.classList.remove('d-none');
      }

      this.displayOnlyWishlistItems();

      if (this.wishlistContainer) {
        if (this.wishlist.length === 0) {
          this.wishlistContainer.classList.add('no_wishlist_items', 'grid-1');
          this.wishlistContainer.classList.remove('grid-4', 'grid-portable-3', 'grid-lap-2');
        } else {
          this.wishlistContainer.classList.remove('no_wishlist_items', 'grid-1');
          this.wishlistContainer.classList.add('grid-4', 'grid-portable-3', 'grid-lap-2');
        }
      }
    }
  }

  bindUIActions() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('wishlist-btn-js')) {
        event.preventDefault();
        const button = event.target;

        this.updateWishlist(button);
        this.toggleButtonState(button);

        setTimeout(() => {
          this.updateWishlistCount();
          if (this.wishlistContainer) {
            if (this.wishlist.length === 0) {
              this.wishlistContainer.classList.add('no_wishlist_items', 'grid-1');
              this.wishlistContainer.classList.remove('grid-4', 'grid-portable-3', 'grid-lap-2');
            } else {
              this.wishlistContainer.classList.remove('no_wishlist_items');
            }
          }
        }, 300);
      }
    });
  }

  loadWishlistItems() {
    const container = document.querySelector(".wishlist_container");
    const wishlistItems = JSON.parse(localStorage.getItem('user_wishlist')) || [];

    if (!container) return;

      // Parallel fetch for all wishlist products      
      const fetchPromises = wishlistItems.map((productHandle) => {
        const url = window.Shopify.routes.root + `products/${productHandle}/?view=card-product`;
        return fetch(url)
          .then(res => res.text())
          .then((responseText) => {
            const htmlDoc = new DOMParser().parseFromString(responseText, 'text/html');
            const productCard = htmlDoc.querySelector('.wishlist-grid');
            if (!productCard) {
              console.warn(`.wishlist-grid not found in card-product view for ${productHandle}`);
            }
            return productCard;
          })
          .catch((error) => {
            console.error(`Error fetching ${productHandle}:`, error);
            return null;
          });
      });
  
      Promise.all(fetchPromises).then(productCards => {
        if (this.wishlistLoader) this.wishlistLoader.style.display = 'none';
        productCards.forEach(card => {
          if (card && container) {
            const clone = card.cloneNode(true);
            container.appendChild(clone);
          }
        });
      });
    
  }

}

// Initialize the Wishlist class
document.addEventListener('DOMContentLoaded', () => {
  new Wishlist();
});
